import { TablePagination } from '@mui/material'

interface TablePaginatorProps {
  colSpan: number
    currentSize: number
    currentPage: number
    totalCount: number
    setCurrentSize: (size: number) => void
    setCurrentPage: (page: number) => void
}

export const TablePaginator = ({ colSpan, currentPage, currentSize, totalCount, setCurrentPage, setCurrentSize }: TablePaginatorProps) => {

  const handleChangePage = (_: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => {
    setCurrentPage(newPage)
  }

  const handleChangeRowsPerPage = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setCurrentSize(parseInt(e.target.value, 10))
  }

  return (
    <TablePagination
      colSpan={colSpan}
      count={totalCount}
      page={currentPage}
      onPageChange={handleChangePage}
      rowsPerPage={currentSize}
      onRowsPerPageChange={handleChangeRowsPerPage}
    />
  )
}